module.exports = __webpack_public_path__ + "placa_compra_inteligente.png?fa9c61cf481ff28d63a8429e245a364f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_compra_inteligente.png
// module id = 122
// module chunks = 0